module.exports = __webpack_public_path__ + "static/media/bim_cuotas.990f3e86.svg";